'use client';
import { appConfig } from '../../utils/appConfig';
import { useNavigationContext } from './index';
import { classNames } from '@repo/ui/src/utils/classNames';
import React from 'react';

export interface NavDropdownWrapperProps {
  children: React.ReactNode;
  open: boolean;
  isDropdown: boolean;
  id: string;
  onTransitionEnd?: (e: React.TransitionEvent<HTMLDivElement>) => void;
}

// eslint-disable-next-line react/display-name
const NavDropdownWrapper = ({
  children,
  open,
  isDropdown,
  id,
  onTransitionEnd,
}: NavDropdownWrapperProps) => {
  const ref = React.useRef<HTMLDivElement>(null);
  const { setHeight, setOffset } = useNavigationContext();

  React.useEffect(() => {
    if (open && isDropdown) {
      setHeight(ref.current?.getBoundingClientRect().height);
    }
    if (!isDropdown) {
      setOffset(open ? ref.current?.getBoundingClientRect().height : 0);
    }
  }, [open, isDropdown, setHeight, setOffset]);

  return (
    <div
      id={id}
      ref={ref}
      className={classNames(
        'tw-flex tw-justify-center tw-absolute tw-top-full tw-left-0 tw-right-0 tw-border-t tw-border-warm-300 -tw-z-10 tw-gap-8 tw-transition-[opacity,transform]',
        appConfig.isMeater && 'tw-bg-neutral-100',
        open
          ? 'tw-opacity-100 tw-delay-200 tw-duration-300'
          : 'tw-pointer-events-none tw-invisible tw-opacity-0 tw-delay-0 tw-duration-200',
      )}
      onTransitionEnd={onTransitionEnd}
      role="region"
    >
      {children}
    </div>
  );
};

export default NavDropdownWrapper;
